import CardArticle from "../../home-blog/components/CardArticle";
import {useArticlePreviews} from "../../../hooks/useArticlePreviews";
import ErrorWrapper from "../../../components/ui/wrappers/ErrorWrapper";
import React from "react";
import Loader from "../../../components/Loader";
import Button from "../../../components/ui/buttons/Button";

const Actualities = () => {
    const {isLoading, articles, error, isError} = useArticlePreviews();

    return <section className={"mb-16"}>
        <h2 className="base-h2-secondary mb-16">Nos actualités</h2>
        {isLoading && <Loader className={"mb-8"}/>}
        {isError && <ErrorWrapper tailwindClass={"mb-8"} error={error?.message || ""}/>}
        {articles && articles.length > 0 && <div className={"mb-8 flex justify-evenly flex-wrap gap-y-6"}>
            {articles.slice(0, 3).map(article => <CardArticle key={article.id} article={article}/>)}
        </div>
        }
        <Button
            text="Voir notre blog"
            link={{href: "/blog", external:false}}
            tailwinClass="mx-auto !block w-fit mb-10"
            btnType="secondary"
            hover={true}
        />
    </section>
}

export default Actualities;